import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { tableStyles } from "../../../../../../Constants/tableStyles";
import theme from "../../../../../../Constants/theme";

const LLMNodeSelectedValues = ({
  handleGeneratePrompt,
  LLM,
  basicPrompt,
  LLMFinetuning,
}) => {
  return (
    <TableContainer
      sx={{
        ...tableStyles.tableContainer,
        maxHeight: "300px",
        overflowY: "auto",
        maxWidth: "95%",
        border: `1px solid ${theme.border.light}`,
        ml: 2,
      }}
    >
      <Table aria-label="simple table">
        <TableHead sx={tableStyles.tableHead}>
          <TableRow>
            <TableCell sx={tableStyles.tableHeaderCell} align="left">
              Parameter
            </TableCell>
            <TableCell sx={tableStyles.tableHeaderCell} align="left">
              Selected Values
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={tableStyles.tableRow}>
            <TableCell
              sx={{
                width: "38%",
                ...tableStyles.tableCell,
              }}
              align="left"
            >
              {" "}
              Foundation Model{" "}
            </TableCell>
            <TableCell sx={tableStyles.tableCell}>
              {" "}
              {Object.keys(LLM)
                .filter((_) => LLM?.[_] === true)
                .join(", ")}{" "}
            </TableCell>
          </TableRow>
          <TableRow sx={tableStyles.tableRow}>
            <TableCell
              sx={{ width: "38%", ...tableStyles.tableCell }}
              align="left"
            >
              Finetuning
            </TableCell>
            <TableCell sx={tableStyles.tableCell}>
              {LLMFinetuning ? "Selected" : "Not selected"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LLMNodeSelectedValues;
